export default __webpack_public_path__ + "static/media/logo-light.e7f12774.png";